import { Box, Stack } from "@mui/material";
import { type UseModalState } from "@src/lib/ui-react";

import { DialogFooter } from "../../components/DialogFooter";
import { Icon } from "../../components/Icon";
import { ResponsiveDialog } from "../../components/ResponsiveDialog";
import { Text } from "../../components/Text";

interface PushNotificationPromptProps {
  modalState: UseModalState;
  onEnable: () => void;
  onDismiss: () => void;
}

const NOTIFICATION_BENEFITS = [
  "Shift booking updates",
  "Chat messages",
  "Schedule changes",
] as const;

export function PushNotificationPrompt(props: PushNotificationPromptProps) {
  const { modalState, onEnable, onDismiss } = props;

  const handleEnable = () => {
    onEnable();
    modalState.closeModal();
  };

  const handleDismiss = () => {
    onDismiss();
    modalState.closeModal();
  };

  return (
    <ResponsiveDialog
      footerContent={
        <DialogFooter
          layout="vertical"
          primaryAction={{
            variant: "contained",
            label: "Got it!",
            onClick: handleEnable,
          }}
          secondaryAction={{
            label: "Not Now",
            variant: "muted",
            onClick: handleDismiss,
          }}
        />
      }
      modalState={modalState}
      title="Stay up to date"
      onClose={handleDismiss}
    >
      <Stack spacing={5} sx={{ alignItems: "center", textAlign: "center" }}>
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: theme.palette.primary.main,
          })}
        >
          <Icon type="bell-solid" size="large" sx={{ color: "primary.contrastText" }} />
        </Box>
        <Text variant="body1">
          Enable push notifications so you never miss important updates like:
        </Text>
        <Stack spacing={1}>
          {NOTIFICATION_BENEFITS.map((benefit) => (
            <Text key={benefit} variant="body2">
              {benefit}
            </Text>
          ))}
        </Stack>
      </Stack>
    </ResponsiveDialog>
  );
}
